import {IBaseLookup} from "./Ibase.lookup";

export namespace PersonReferenceType {

    export const lookupName: string = "PersonReferenceType";

    export interface PersonReferenceType {
        personReferenceTypeKey: number;
        description: string;
        active: string;
        mappingTagName: string;
        lastUpdated: Date;
        resourceRoleKey: number;
        showInScheduler: string;
    }

    export interface PersonReferenceTypeDS extends IBaseLookup {
        personReferenceType: PersonReferenceType[];
    }
}
